import React from 'react';
import { cn } from '@/lib/utils';
import { getPlatformMeta } from '../lib/leadMeta';

interface PlatformChipProps {
  platform?: string;
  className?: string;
}

/** Small icon chip tinted with the platform's `channel-*` brand token. */
export function PlatformChip({ platform, className }: PlatformChipProps) {
  const meta = getPlatformMeta(platform);
  const Icon = meta.icon;

  return (
    <span
      className={cn('inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-md', meta.className, className)}
      title={meta.label}
    >
      <Icon className="h-3.5 w-3.5" aria-hidden="true" />
      <span className="sr-only">{meta.label}</span>
    </span>
  );
}
